export const CODE_STATE = {
  INVALID: "invalid", // Code isn't invalid/doesn't exist
  DUPLICATE: "duplicate", // Code has already been awarded
  FAILED: "failed", // Code not awarded due to questions not answered correctly
  AWARDED: "awarded" // Code has been awarded
};

export const TIME_FILTERS = {
  ALL_TIME: "all-time",
  WEEKLY: "weekly"
};

export const LEADERBOARD_FILTERS = {
  INDIVIDUAL: "individual",
  GROUPS: "groups"
};

export const DEFAULT_SELECT_VALUE = {
  STUDENT: "Select a student",
  ACHIEVEMENT: "Select an achievement"
};

// enums of groups to match via name to ensure consistent colors
export const GROUP_DETAILS = [
  { name: "House Damwright", group: "0" },
  { name: "House Howlmoor", group: "1" },
  { name: "House Ironjaw", group: "2" },
  { name: "House Timberblast", group: "3" }
];
